import { useCallback, useState } from "react"
import { useAppContext } from "~/app.use-app-context.hook"
import {
  isLoading,
  match,
  withFailure,
  withSuccess,
} from "~/store/async-store.utils"
import type { Country } from "./country.model"

type State = {
  countries: Country[]
  isLoading: boolean
  error: string | null
}

export function useCountriesStore() {
  const {
    countriesModule: { service, store },
  } = useAppContext()
  const [state, setState] = useState<State>({
    countries: withSuccess(store.state, [], ({ countries }) => countries),
    isLoading: isLoading(store.state),
    error: withFailure(store.state, null, (error) => error),
  })

  store.addListener(
    match({
      onInitial: () => {
        setState({
          countries: [],
          isLoading: false,
          error: null,
        })
      },
      onLoading: () => {
        setState({ ...state, isLoading: true })
      },
      onFailure: (error) => {
        setState({ ...state, error, isLoading: false })
      },
      onSuccess: ({ countries }) => {
        setState({
          countries,
          isLoading: false,
          error: null,
        })
      },
    }),
  )

  const fetchCountries = useCallback(async () => {
    await service.fetchAll()
  }, [service])

  return {
    state,
    actions: { fetchCountries },
  }
}
